import { AppDispatch } from "../store";
import secureLocalStorage from "react-secure-storage";
import { logout } from "./sessionSlice";
import { API } from "../../http/api";
import http from "../../http/axios_auth";
import { Utils } from "../../utils/constantes";

type AuthSession = {
  session?: {
    access_token?: string;
  };
};

export const logoutAsync = () => async (dispatch: AppDispatch) => {
  try {
    const rawAuth = secureLocalStorage.getItem("auth");

    let session: { access_token?: string } | undefined;

    if (typeof rawAuth === "string") {
      try {
        const parsed = JSON.parse(rawAuth);
        session = parsed?.session;
      } catch (e) {
        console.warn("Could not parse auth from secureLocalStorage:", e);
      }
    } else if (typeof rawAuth === "object" && rawAuth !== null) {
      session = (rawAuth as any).session;
    }

    if (session?.access_token) {
      const form = new URLSearchParams();
      form.append("token", session.access_token);
      form.append("client_id", Utils.clientId);

      await http.post(API.logout, form.toString(), {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });
    }
  } catch (err) {
    console.warn("Logout API error (silent):", err);
  }

  http.defaults.headers.common["Authorization"] = "";

  secureLocalStorage.removeItem("auth");
  dispatch(logout());
};

